
import React, { useState } from 'react';
import DashboardStats from './components/DashboardStats';
import OrderManagement from './components/OrderManagement';
import MenuManagement from './components/MenuManagement';
import TableManagement from './components/StaffManagement'; // Renamed to TableManagement
import ReportsSection from './components/ReportsSection';

export default function AdminPage() {
  const [activeSection, setActiveSection] = useState('dashboard');

  const tabs = [
    { id: 'dashboard', name: 'Dashboard', icon: 'ri-dashboard-line' },
    { id: 'orders', name: 'Pesanan', icon: 'ri-file-list-line' },
    { id: 'menu', name: 'Menu', icon: 'ri-restaurant-line' },
    { id: 'staff', name: 'Staf', icon: 'ri-team-line' },
    { id: 'reports', name: 'Laporan', icon: 'ri-bar-chart-line' }
  ];

  const renderContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return <DashboardStats />;
      case 'orders':
        return <OrderManagement />;
      case 'menu':
        return <MenuManagement />;
      case 'staff':
        return <TableManagement />;
      case 'reports':
        return <ReportsSection />;
      default:
        return <DashboardStats />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black">
      {/* Header */}
      <div className="bg-gradient-to-r from-red-900/50 to-yellow-900/50 backdrop-blur-sm border-b border-red-500/20">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <span className="text-6xl" style={{ fontFamily: '"Noto Sans JP", serif' }}>竹</span>
              <div>
                <h1 className="text-3xl font-bold text-white">TAKEYA Admin</h1>
                <p className="text-yellow-400">Restaurant Management System</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              <div className="bg-black/30 rounded-2xl px-6 py-3">
                <div className="text-center">
                  <p className="text-white font-bold text-lg">
                    {new Date().toLocaleDateString('id-ID', { 
                      weekday: 'long',
                      day: '2-digit', 
                      month: 'long',
                      year: 'numeric'
                    })}
                  </p>
                  <p className="text-gray-300 text-sm">
                    {new Date().toLocaleTimeString('id-ID', { 
                      hour: '2-digit', 
                      minute: '2-digit'
                    })}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-gray-800/50 backdrop-blur-sm border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveSection(tab.id)}
                className={`flex items-center space-x-3 px-6 py-4 font-semibold transition-all duration-300 border-b-2 whitespace-nowrap cursor-pointer ${
                  activeSection === tab.id
                    ? 'text-red-400 border-red-500'
                    : 'text-gray-300 border-transparent hover:text-white hover:border-gray-600'
                }`}
              >
                <i className={`${tab.icon} w-5 h-5 flex items-center justify-center`}></i>
                <span>{tab.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        {renderContent()}
      </div>
    </div>
  );
}
